export const serializeDate = (dateTime: string): string => {
  const dateTimeArr = dateTime.split(' ')
  const dateArr = dateTimeArr[0].split('-')

  return dateArr[2] + '.' + dateArr[1] + '.' + dateArr[0].slice(2, dateArr[0].length) + ' ' + dateTimeArr[1]
}
